import React from 'react';
import { Link } from '@inertiajs/react';
import { Button } from '@/components/ui/button';
import { LayoutDashboard } from 'lucide-react';

interface HeaderProps {
  auth: {
    user: any | null;
  };
  showWaitingList?: boolean;
}

export function Header({ auth, showWaitingList }: HeaderProps) {

  const scrollToWaitingList = () => {
    const element = document.getElementById('waiting-list');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  
  return (
    <header>
      <div className="container mx-auto px-4 py-8 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Link href="/">
            <img src="/images/protribe-logo.svg" alt="Protribe" className="h-8" />
          </Link>
          <span className="bg-yellow-100 text-[#006DE4] px-2 py-0.5 rounded text-xs font-semibold">
            Beta
          </span>
        </div>
        
        <div className="flex items-center gap-4">
          {auth.user ? (
            <Button
              variant="outline"
              className="bg-blue-600 border-blue-600 text-white hover:bg-blue-700 hover:border-blue-700 hover:text-white font-semibold transition-all duration-200 hover:shadow-md"
              asChild
            >
              <Link href={route('dashboard')}>
                <LayoutDashboard className="w-4 h-4" />
                Dashboard
              </Link>
            </Button>
          ) : (
            <>
              <Link
                href={route('login')}
                className="inline-block rounded-md px-5 py-2.5 text-sm font-medium leading-normal text-[#1b1b18] hover:bg-white hover:shadow-sm transition-all duration-200"
              >
                Log in
              </Link>

              {showWaitingList ? (
                <Button
                  variant="default"
                  className="bg-[#ffc20e] hover:bg-[#e5af0c] text-[#1b1b18] font-semibold"
                  onClick={scrollToWaitingList}
                >
                  Join our waiting list
                </Button>
              ) : (
                <Button
                  variant="default"
                  className="bg-[#ffc20e] hover:bg-[#e5af0c] text-[#1b1b18] font-semibold"
                  asChild
                >
                  <Link href="/onboarding/welcome">
                    Join Protribe
                  </Link>
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </header>
  );
} 